import { ReactNode } from 'react';
import { Progress } from '@/components/ui/progress';

interface OnboardingLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  footer?: ReactNode;
}

export const OnboardingLayout = ({ children, currentStep, totalSteps, footer }: OnboardingLayoutProps) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="onboarding-container flex flex-col bg-gradient-soft">
      {/* Header fixe */}
      <div className="flex-shrink-0 pt-safe-area-top pb-4">
        <div className="flex items-center justify-center mb-4 pt-4">
          <span className="text-lg font-medium text-foreground">{currentStep}/{totalSteps}</span>
        </div>
        <div className="w-full">
          <Progress value={progress} className="h-1 bg-muted">
            <div className="h-full bg-[hsl(var(--violet-primary))] rounded-full transition-all duration-300" style={{ width: `${progress}%` }} />
          </Progress>
        </div>
      </div>

      {/* Contenu scrollable */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>

      {/* Footer fixe */}
      {footer && (
        <div className="flex-shrink-0 p-6 pb-8 bg-background/80 backdrop-blur-sm border-t border-border/50">
          {footer}
        </div>
      )}
    </div>
  );
};